import styled from "styled-components";
import { COLORS } from "../../../constants/colors";
import EplusTable from "../../molecules/showcase/EplusTable";
import EplusSelectBox from "../../molecules/showcase/EplusSelectBox";
import PublicPaging from "../../publics/PublicPaging";
import { EplusTableCardProps } from "../../../constants/types";

const EplusTableCard = (props: EplusTableCardProps) => {
  return (
    <Container>
      <EplusSelectBox
        option={props.option}
        categories={props.categories}
        render={props.render}
      />
      <EplusTable data={props.data} page={props.page} />
      <PublicPaging dataLength={props.data.length} page={props.page} />
    </Container>
  );
};

export default EplusTableCard;

const Container = styled.div`
  width: 39%;
  height: 100%;
  border: 0.2vw solid ${COLORS.lightGray};
  box-sizing: border-box;

  padding: 1%;

  display: flex;
  align-content: space-between;
  flex-wrap: wrap;
`;
